export const SITE_CONTENT_SCHEMA = {
  global_nav: {
    label: 'Global navigation',
    defaults: {
      brand_label: 'Härryda BBQ',
      brand_alt: 'Härryda BBQ',
      home_label: 'Hem',
      home_url: '/',
      catering_label: 'Catering',
      catering_url: '/catering',
      products_label: 'Produkter',
      products_url: '/produkter',
      products_visible: 'true',
      pulled_pork_label: 'Pulled pork',
      pulled_pork_url: '/pulled-pork',
      brisket_label: 'Brisket',
      brisket_url: '/brisket',
      order_label: 'Förbeställ',
      order_url: '/order',
      order_visible: 'true',
      shop_label: 'Shop',
      shop_url: '/shop',
      values_label: 'Våra värderingar',
      values_url: '/#varderingar',
      contact_label: 'Kontakt',
      contact_url: '/kontakt',
      cta_label: 'Skicka cateringförfrågan',
      cta_url: '/catering',
    },
  },
  global_footer: {
    label: 'Global footer',
    defaults: {
      tagline: 'Barbecue rökt med ved och tålamod i Härryda, strax utanför Göteborg.',
      contact_title: 'Kontakt',
      links_title: 'Sidor',
      social_title: 'Följ oss',
      hours_title: 'Öppettider',
      hours_text: '',
      org_text: '',
    },
  },
  business_identity: {
    label: 'Företagsidentitet och platser',
    defaults: {
      phone: '0762 - 386 730',
      email: 'info@harrydabbq.se',
      smokehouse_name: '',
      smokehouse_description: '',
      smokehouse_street_address: '',
      smokehouse_postal_code: '',
      smokehouse_locality: '',
      vassen_name: 'Vassen Market',
      vassen_description: 'Stängt för säsongen',
      vassen_street_address: '',
      vassen_postal_code: '',
      vassen_locality: '',
      instagram_url: 'https://www.instagram.com/harrydabbq/',
      facebook_url: 'https://www.facebook.com/p/H%C3%A4rryda-BBQ-100092224822166/',
      tiktok_url: '',
      youtube_url: '',
    },
    fields: {
      phone: { label: 'Telefonnummer', type: 'tel' },
      email: { label: 'E-postadress', type: 'email' },
      smokehouse_name: { label: 'Namn på smokehouse/produktionsplats', type: 'text' },
      smokehouse_description: { label: 'Beskrivning av smokehouse/produktion', type: 'textarea' },
      smokehouse_street_address: { label: 'Smokehouse/produktion: gatuadress', type: 'text' },
      smokehouse_postal_code: { label: 'Smokehouse/produktion: postnummer', type: 'text' },
      smokehouse_locality: { label: 'Smokehouse/produktion: ort', type: 'text' },
      vassen_name: { label: 'Namn på Vassen-platsen', type: 'text' },
      vassen_description: { label: 'Beskrivning av Vassen Market', type: 'textarea' },
      vassen_street_address: { label: 'Vassen Market: gatuadress', type: 'text' },
      vassen_postal_code: { label: 'Vassen Market: postnummer', type: 'text' },
      vassen_locality: { label: 'Vassen Market: ort', type: 'text' },
      instagram_url: { label: 'Instagram-URL', type: 'url' },
      facebook_url: { label: 'Facebook-URL', type: 'url' },
      tiktok_url: { label: 'TikTok-URL', type: 'url' },
      youtube_url: { label: 'YouTube-URL', type: 'url' },
    },
  },
  home_hero: {
    label: 'Home hero',
    legacySections: ['hero'],
    fieldAliases: {
      lead: ['content'],
    },
    defaults: {
      kicker: 'INGEN BULLSHIT, BARA KÄRLEK OCH RÖK!',
      title: 'Premium-BBQ för företag och stora fester.',
      lead: 'Riktigt hantverk, lokala och svenska råvaror, långsam rökning och en servering som känns lika genomarbetad som eventet du planerar.',
      primary_cta_label: 'Skicka cateringförfrågan',
      primary_cta_url: '/catering',
      secondary_cta_label: 'Våra värderingar',
      secondary_cta_url: '#varderingar',
      card_aria_label: 'Härryda BBQ premiumupplevelse',
      card_eyebrow: 'Premiumupplevelse',
      card_title: 'Rökverket på plats',
      card_body: 'Doften, råvaran och serveringen ska kännas innan första tallriken lämnar bordet.',
    },
  },
  home_values_header: {
    label: 'Home values header',
    legacySections: ['philosophy'],
    fieldAliases: {
      heading: ['title', 'highlight'],
      lead: ['content'],
    },
    defaults: {
      kicker: 'VÅRA VÄRDERINGAR',
      heading: 'Ingen bullshit. Bara kärlek och rök.',
      lead: 'Det betyder råvaror vi kan stå för, leverantörer vi känner och BBQ som får ta den tid den behöver.',
    },
  },
  home_value_1: {
    label: 'Home value card 1',
    legacySections: ['philosophy_1'],
    fieldAliases: {
      body: ['text', 'content'],
      text: ['body', 'content'],
    },
    defaults: {
      kicker: 'RÅVAROR',
      title: 'Lokalt och svenskt när det går',
      body: 'Vi väljer lokalproducerat eller svenskproducerat i möjligaste mån — inte för att det låter fint, utan för att det smakar bättre och går att stå för.',
    },
  },
  home_value_2: {
    label: 'Home value card 2',
    legacySections: ['philosophy_2'],
    fieldAliases: {
      body: ['text', 'content'],
      text: ['body', 'content'],
    },
    defaults: {
      kicker: 'RELATIONER',
      title: 'Leverantörer vi faktiskt känner',
      body: 'Vi vill jobba med leverantörer som har blivit affärsbekanta. Människor vi kan ringa även en lördagskväll om något behöver lösas.',
    },
  },
  home_value_3: {
    label: 'Home value card 3',
    legacySections: ['philosophy_3'],
    fieldAliases: {
      body: ['text', 'content'],
      text: ['body', 'content'],
    },
    defaults: {
      kicker: 'HANTVERK',
      title: 'Rök, tid och respekt',
      body: 'BBQ går inte att stressa fram. Rätt ved, rätt temperatur och tålamod är en del av värderingen — inte bara tekniken.',
    },
  },
  home_premium_proof: {
    label: 'Home premium proof',
    defaults: {
      kicker: 'Varför premium',
      heading: 'Inte catering per person. Ett rökverk till ditt event.',
      lead: 'När priset ska kännas självklart behöver kunden se vad som ligger bakom: råvaran, tiden vid röken, portionerna, upplägget och tryggheten i att gästerna får något de minns.',
      proof_1: 'Företagsfester',
      proof_2: 'Sommarfester',
      proof_3: 'Kickoffer',
      proof_4: 'Stora privata firanden',
      links_title: 'Läs mer om vårt rökta kött',
      link_1_label: 'Pulled pork',
      link_1_url: '/pulled-pork',
      link_2_label: 'Brisket',
      link_2_url: '/brisket',
    },
  },
  home_next_step: {
    label: 'Home next step panel',
    defaults: {
      kicker: 'Nästa steg',
      title: 'Berätta antal, datum och plats.',
      body: 'Vi återkommer med rätt upplägg, råvarutänk och en offert som matchar nivån på festen.',
      cta_label: 'Skicka cateringförfrågan',
      cta_url: '/catering',
    },
  },
  contact_page: {
    label: 'Kontaktsida',
    defaults: {
      kicker: 'Kontakt',
      title: 'Prata BBQ med oss.',
      lead: 'Ring eller maila om catering, batcher och större upplägg. För snabbast svar på catering: skicka en förfrågan med datum, antal och plats.',
      primary_cta_label: 'Ring oss',
      secondary_cta_label: 'Maila oss',
      card_eyebrow: 'Direktkontakt',
      card_title: 'Datum, plats och antal först.',
      card_body: 'Då kan vi snabbt avgöra om upplägget passar röken, teamet och nivån du vill ha.',
      phone_body: 'Ring oss direkt när det gäller datum, upplägg eller snabb avstämning.',
      phone_cta_label: 'Ring oss',
      email_body: 'Skicka frågor, företagsuppgifter eller annan information vi behöver inför offert.',
      email_cta_label: 'Maila oss',
      catering_label: 'Catering',
      catering_title: 'Starta förfrågan',
      catering_body: 'Välj BBQ-upplägg, antal personer, datum och plats så räknar sidan fram en prisbild.',
      catering_cta_label: 'Till catering',
      form_kicker: 'Skicka meddelande',
      form_title: 'Hellre skriva än ringa?',
      form_body: 'Fyll i formuläret så återkommer vi så snart vi kan. Gäller det catering går det snabbare via cateringförfrågan.',
      form_cta_label: 'Skicka meddelande',
      form_success: 'Tack för ditt meddelande! Vi återkommer så snart vi kan.',
    },
    fields: {
      form_kicker: { label: 'Formulär: kicker', type: 'text' },
      form_title: { label: 'Formulär: rubrik', type: 'text' },
      form_body: { label: 'Formulär: brödtext', type: 'textarea' },
      form_cta_label: { label: 'Formulär: knapptext', type: 'text' },
      form_success: { label: 'Formulär: bekräftelsetext', type: 'textarea' },
    },
  },
  catering_page: {
    label: 'Cateringoffert',
    defaults: {
      kicker: 'Cateringförfrågan',
      title: 'Rökt BBQ till festen — bygg offerten direkt.',
      lead: 'Välj upplägg, antal och datum. Du får en levande prisbild direkt — vi bekräftar detaljerna personligen.',
      mark_label: 'Härryda BBQ',
      mark_title: 'Catering',
      primary_cta_label: 'Bygg offert',
      secondary_cta_label: 'Se alternativen',
      builder_kicker: 'Offertbyggare',
      builder_title: 'Fem val. Ett tydligt pris.',
      builder_lead: 'Starta med grunderna, välj BBQ-upplägg och skicka bara när prisbilden känns rätt.',
      event_section_title: 'Starta med grunderna',
      package_section_title: 'Välj BBQ-upplägg',
      delivery_section_title: 'Leveransadress',
      location_section_title: 'Plats',
      delivery_address_label: 'Adress för utkörning',
      delivery_address_placeholder: 'Gata, postnr, ort',
      delivery_help_prefix: 'Avstånd och framkörning beräknas automatiskt från',
      delivery_manual_distance_label: 'Avstånd kunde inte beräknas automatiskt — ange avstånd (mil, enkel väg) så räknar vi preliminärt:',
      delivery_price_needs_address: 'Ange leveransadress för att beräkna framkörning och totalpris.',
      allergy_section_title: 'Allergier & specialkost',
      contact_section_title: 'Kontaktuppgifter',
      price_section_title: 'Din prisuppskattning',
      submit_label: 'Skicka förfrågan',
      receipt_title: 'Tack för din förfrågan!',
      receipt_lead: 'Vi återkommer inom 24 timmar. Detta är en förfrågan — inte en bekräftad bokning.',
    },
  },
  catering_seo: {
    label: 'Catering SEO-innehåll',
    defaults: {
      intro_kicker: 'Barbecue-catering i Göteborg och Härryda',
      intro_title: 'Catering med grillat och rökt kött till event',
      intro_lead: 'Härryda BBQ levererar barbecue-catering i Härryda, Göteborg och orterna däromkring. Vi röker pulled pork, brisket och ribs med ved och tålamod, kör ut till er lokal och sköter serveringen på plats. Räkna ut ditt pris i formuläret ovan och skicka en kostnadsfri offertförfrågan.',
      intro_link_label: 'Läs mer om vår rökta pulled pork',
      intro_link_url: '/pulled-pork',
      audience_1_kicker: 'Företag',
      audience_1_title: 'Företagsevent & kick-off',
      audience_1_body: 'BBQ-catering för kick-offer, personalfester och kundevent i Göteborg. Vi kommer ut till kontoret eller festlokalen, dukar upp buffén och serverar — ni fokuserar på gästerna. Fakturering till företag, ange bara org.nr i förfrågan.',
      audience_2_kicker: 'Fest',
      audience_2_title: 'Bröllop & privata fester',
      audience_2_body: 'Rökt kött är en festmåltid som märks. Vi levererar catering till bröllop, födelsedagar, studentskivor och familjefiranden i hela Göteborgsområdet — med buffé, tillbehör och personal som sköter serveringen på plats.',
      audience_3_kicker: 'Sommar',
      audience_3_title: 'Sommarfest & mingel',
      audience_3_body: 'Burgartruck eller BBQ-buffé utomhus — live-grillning som doftar över hela festen. Perfekt för sommarfester, grannskapsfester och mingel där maten är en del av upplevelsen.',
      areas_kicker: 'Leveransområde',
      areas_title: 'Vi kör ut i hela Göteborgsområdet',
      areas_lead: 'Vi levererar catering till bland annat följande orter:',
      areas_list: 'Göteborg, Mölndal, Partille, Mölnlycke, Härryda, Landvetter, Lerum, Kungsbacka',
      steps_kicker: 'Så funkar det',
      steps_title: 'Från förfrågan till fest i tre steg',
      steps_body: '1. Välj upplägg och antal gäster i formuläret — du ser prisuppskattningen direkt. 2. Skicka förfrågan, så återkommer vi och spikar menyn och detaljerna. 3. På dagen kommer vi ut, dukar upp och serverar.',
      faq_kicker: 'Vanliga frågor',
      faq_title: 'Frågor och svar om BBQ-catering i Göteborg',
      faq_1_question: 'Levererar ni BBQ-catering i Härryda och Göteborg?',
      faq_1_answer: 'Ja, vi kör ut catering i Härryda och hela Göteborg med omnejd — bland annat Mölndal, Partille, Mölnlycke, Landvetter, Lerum och Kungsbacka. Framkörningen beräknas automatiskt på adressen du anger i offertformuläret.',
      faq_2_question: 'Vad kostar BBQ-catering per person?',
      faq_2_answer: 'Priset beror på vilket upplägg du väljer och hur många gäster ni är. Ange antal personer och upplägg i formuläret så ser du en prisuppskattning direkt — helt utan förpliktelser. Offertförfrågan är alltid kostnadsfri.',
      faq_3_question: 'Vad serverar ni på en BBQ-catering?',
      faq_3_answer: 'Låg- och långsamt rökt kött på riktigt: pulled pork, brisket, ribs och oxkind, rökta med ved och tålamod. Exakt innehåll ser du i respektive upplägg i offertformuläret.',
      faq_4_question: 'Hanterar ni allergier och specialkost?',
      faq_4_answer: 'Ja. I förfrågan markerar du vilka av EU:s 14 allergener som förekommer bland gästerna och anger antal vegetariska eller veganska portioner, så anpassar vi menyn.',
      faq_5_question: 'Hur många gäster klarar ni?',
      faq_5_answer: 'Från mindre sällskap till stora företagsevent och bröllop. Minsta antal gäster varierar per upplägg och visas i offertformuläret.',
      faq_6_question: 'Hur långt i förväg behöver vi boka?',
      faq_6_answer: 'Rökt kött tar tid att göra rätt, så boka gärna ett par veckor i förväg — särskilt inför helger och sommarsäsongen. Skicka en förfrågan så återkommer vi snabbt med bekräftelse.',
    },
  },
  pulled_pork_page: {
    label: 'Pulled pork (landningssida)',
    defaults: {
      title: 'Pulled pork – rökt på riktigt',
      lead: 'Pulled pork är fläsk som rökts länge på låg värme tills det går att dra isär med två gafflar. Vi gör den med svenskt fläsk, ved och tålamod i vår offset smoker i Härryda utanför Göteborg – ingen ugn, inga genvägar.',
      section_1_title: 'Så röker vi vår pulled pork',
      section_1_body: 'Köttet kryddas med vår egen rub och läggs i röken tidigt på morgonen. Sedan får det ta den tid det tar: låg temperatur, riktig ved och en rökring som sätter sig i köttet. När det är klart drar vi isär det för hand och blandar med skyn så att det håller sig saftigt. Inga tillsatser, inga E-nummer.',
      section_2_title: 'Köp färdigrökt pulled pork',
      section_2_body: 'Vi röker i batcher och säljer pulled pork färdigrökt, redo att värmas hemma. Se vad som finns just nu bland våra produkter eller fråga oss om nästa batch.',
      section_2_cta_label: 'Se våra produkter',
      section_2_cta_url: '/produkter',
      section_3_title: 'Pulled pork till fest och företagsevent',
      section_3_body: 'Pulled pork ingår i alla våra BBQ-cateringupplägg. Vi kommer ut till er i Göteborg, Mölndal, Partille, Härryda, Lerum och Kungsbacka, dukar upp och serverar. Räkna ut ett pris direkt i offertformuläret.',
      section_3_cta_label: 'Räkna ut pris på catering',
      section_3_cta_url: '/catering',
      section_4_title: 'Så serverar du pulled pork',
      section_4_body: 'Klassikern är i ett mjukt bröd med coleslaw, pickles och barbecuesås. Den funkar lika bra på en tallrik med potatissallad och pit beans, i tacos eller på en pizza. Räkna med ungefär 150–200 gram per person som huvudrätt.',
      section_4_cta_label: 'Läs om vår brisket',
      section_4_cta_url: '/brisket',
      faq_title: 'Vanliga frågor om pulled pork',
      faq_1_question: 'Vad är pulled pork?',
      faq_1_answer: "Pulled pork är fläskkött som rökts eller tillagats långsamt på låg värme tills bindväven mjuknat så mycket att köttet går att dra isär i strimlor. Namnet kommer från att man drar, 'pullar', köttet.",
      faq_2_question: 'Hur länge röks pulled pork?',
      faq_2_answer: 'Många timmar. Exakt hur länge beror på köttets storlek och temperaturen i smokern. Vi går på känsla och termometer, inte på klockan, och tar ut köttet när det är klart.',
      faq_3_question: 'Kan jag köpa färdig pulled pork i Göteborg?',
      faq_3_answer: 'Ja. Vi säljer vår rökta pulled pork i batcher via sajten. Den är färdigrökt och behöver bara värmas.',
      faq_4_question: 'Hur värmer jag pulled pork?',
      faq_4_answer: 'Värm den försiktigt i kastrull eller ugn på låg värme med lite av skyn eller en skvätt vatten så att den inte torkar. Den ska bli genomvarm, inte stekas.',
      faq_5_question: 'Kan ni leverera pulled pork till en fest eller ett företagsevent?',
      faq_5_answer: 'Ja, pulled pork ingår i våra cateringupplägg. Vi levererar och serverar i Göteborg med omnejd. Skicka en offertförfrågan så återkommer vi.',
      faq_6_question: 'Är pulled pork gjord på svenskt kött?',
      faq_6_answer: 'Ja. Vi använder svenskt fläsk från leverantörer vi känner, utan tillsatser och E-nummer.',
    },
  },
  brisket_page: {
    label: 'Brisket (landningssida)',
    defaults: {
      title: 'Brisket – rökt nötbringa som i Texas',
      lead: 'Brisket är nötbringa som röks långsamt tills den är mör rakt igenom, med mörk bark utanpå och saftigt kött inuti. Vi röker den med ved och tålamod i Härryda utanför Göteborg och skivar den på brickor, som traditionen bjuder i Texas.',
      section_1_title: 'Så röker vi vår brisket',
      section_1_body: 'Bringan kryddas enkelt, salt och peppar bär det mesta, och får ligga i röken i många timmar på låg temperatur. Sedan får den vila innan vi skivar den tvärs över fibrerna, det är då den blir så mör som den ska. Svenskt nötkött, inga tillsatser, inga E-nummer.',
      section_2_title: 'Brisket, pulled beef och oxkind',
      section_2_body: 'Brisket är inte det enda nötköttet från vår smoker. Pulled beef är långrökt nöt som dras isär på samma sätt som pulled pork, och rökt oxkind, smoked confit beef cheek, är det möraste vi gör och ingår i alla våra cateringupplägg.',
      section_2_cta_label: 'Läs om vår pulled pork',
      section_2_cta_url: '/pulled-pork',
      section_3_title: 'Brisket till fest och företagsevent',
      section_3_body: 'Vill ni ha brisket på festen eller kick-offen? Vi kommer ut till er i Göteborg, Mölndal, Partille, Härryda, Lerum och Kungsbacka, dukar upp och serverar. Skriv i offertförfrågan att ni vill ha brisket på brickan så sätter vi ihop upplägget.',
      section_3_cta_label: 'Räkna ut pris på catering',
      section_3_cta_url: '/catering',
      section_4_title: 'Köp rökt kött och chark',
      section_4_body: 'Vi röker i batcher och säljer rökt kött och chark via sajten. Se vad som finns just nu eller fråga oss om nästa batch.',
      section_4_cta_label: 'Se våra produkter',
      section_4_cta_url: '/produkter',
      faq_title: 'Vanliga frågor om brisket',
      faq_1_question: 'Vad är brisket?',
      faq_1_answer: 'Brisket är nötbringa, en muskel med mycket bindväv som blir seg om den tillagas snabbt men smälter till mört, saftigt kött när den röks länge på låg värme. Det är det klassiska köttet i Texas-barbecue.',
      faq_2_question: 'Vad är skillnaden mellan brisket och pulled beef?',
      faq_2_answer: 'Brisket skivas och serveras i skivor med barken kvar. Pulled beef är rökt nötkött som dras isär i strimlor, som pulled pork fast av nöt. Båda röks länge på låg temperatur.',
      faq_3_question: 'Hur länge röks en brisket?',
      faq_3_answer: 'Längre än det mesta, ofta en hel dag. Exakt tid beror på bringans storlek och smokerns temperatur. Vi går på känsla och termometer, inte på klockan.',
      faq_4_question: 'Hur skär man brisket?',
      faq_4_answer: 'Tvärs över köttfibrerna, i skivor ungefär lika tjocka som en penna. Skär man längs med fibrerna blir även en perfekt rökt brisket seg att tugga.',
      faq_5_question: 'Kan ni servera brisket på vårt event i Göteborg?',
      faq_5_answer: 'Ja. Skriv i offertförfrågan att ni vill ha brisket så lägger vi till den i ert cateringupplägg. Vi levererar och serverar i Göteborg med omnejd.',
      faq_6_question: 'Är er brisket gjord på svenskt kött?',
      faq_6_answer: 'Ja. Vi använder svenskt nötkött från leverantörer vi känner, utan tillsatser och E-nummer.',
    },
  },
  products_v2_hero: {
    label: 'Produkter v2 hero',
    defaults: {
      kicker: 'Produkter',
      title: 'Produkter från röken',
      lead: 'Långrökt BBQ, chark och sides byggda för människor som märker skillnad. Det här är sortimentet som ska sälja doften innan gästen ens smakat.',
      category_aria_label: 'Produktkategorier',
      marquee_aria_label: 'Exempel på produkter',
    },
  },
  products_v2_group_bbq: {
    label: 'Produkter v2 BBQ-kategori',
    defaults: {
      eyebrow: 'Långrökt',
      label: 'BBQ från röken',
      title: 'Rökta produkter byggda för stora smakögonblick.',
      text: 'Pulled pork, ribs, oxkind, kycklingvingar och sides som gör att ett event känns som Härryda BBQ innan någon ens hunnit sätta sig.',
      link_label: 'Läs mer om vår rökta pulled pork',
      link_url: '/pulled-pork',
    },
  },
  products_v2_group_chark: {
    label: 'Produkter v2 chark-kategori',
    defaults: {
      eyebrow: 'Chark',
      label: 'Chark från smokehouse',
      title: 'Rökta småskaliga produkter med egen karaktär.',
      text: 'Bacon, pastej, korv, skinka och annat som passar i butik, på julbordet eller i kylen hemma.',
    },
  },
  products_v2_proof: {
    label: 'Produkter v2 proof-ruta',
    defaults: {
      aria_label: 'Sortimentsöversikt',
      kicker: 'Live',
      ready_status: 'Synkad med produktdatabasen',
      preview_status: 'Designläge med fallback',
      body: 'Sidan visar aktiva produkter från produktdatabasen. Fallback visas bara om API:t är tomt eller inte går att nå.',
    },
  },
  products_v2_labels: {
    label: 'Produkter v2 etiketter',
    defaults: {
      show_prefix: 'Visa',
      switch_prefix: 'Byt till',
      switch_aria_label: 'Byt produktkategori',
      sortiment_label: 'Sortiment',
      contact_label: 'Prata sortiment',
      contact_url: '/kontakt',
      admin_badge: 'Från produktdatabasen',
      serve_label: 'Passar med',
      price_on_request: 'Pris på förfrågan',
      product_default_headline: 'Rökt hantverk från Härryda BBQ.',
      product_default_description: 'En produkt från smokehouse-sortimentet. Mer information kommer när nästa batch är satt.',
      product_default_tag: 'Smokehouse',
      product_request_tag: 'Förfrågan',
      product_inactive_tag: 'Ej aktiv',
      product_default_serve: 'Kontakta oss för aktuell batch och tillgänglighet',
      empty_kicker: 'Saknas i produktdatabasen',
      empty_title: 'Inga aktiva produkter i den här kategorin ännu.',
      empty_body: 'Lägg till produkter i admin under Produkter så visas de här automatiskt.',
    },
  },
  products_v2_cta: {
    label: 'Produkter v2 CTA',
    defaults: {
      kicker: 'Nästa steg',
      title: 'Vill du köpa, boka eller sälja våra produkter?',
      body: 'Vi använder den här sidan för att sälja in sortimentet. När besökaren är sugen ska nästa steg vara enkelt: prata produkt, boka BBQ till event eller fråga om återförsäljning.',
      primary_label: 'Kontakta oss',
      primary_url: '/kontakt',
      secondary_label: 'Boka till event',
      secondary_url: '/catering',
    },
  },
  seo_catering: {
    label: 'SEO catering',
    defaults: {
      title: 'BBQ-catering Göteborg – Pulled Pork, Brisket & Ribs | Härryda BBQ',
      description: 'BBQ-catering och grillcatering i Göteborg och Härryda – rökt pulled pork, brisket och ribs till event, kick-off och bröllop. Kostnadsfri offertförfrågan, svar inom 24 h.',
    },
  },
  seo_order: {
    label: 'SEO beställ (jul)',
    defaults: {
      intro_title: 'Rökt julskinka, jullådor och chark från röken i Härryda',
      intro_lead: 'Här förbeställer du julens chark från Härryda BBQ: ekrökt julskinka utan nitritsalt, jullådor och charklådor med korv, bacon och rökta köttbullar, och enskilda charkprodukter. Allt röks i Härryda utanför Göteborg av svenskt kött, utan tillsatser och E-nummer. Sista beställningsdag, hämtning och hemkörning står överst på sidan.',
      faq_title: 'Vanliga frågor om julbeställningen',
      faq_1_question: 'Hur beställer jag?',
      faq_1_answer: 'Lägg produkterna i varukorgen, fyll i namn, e-post och telefon och skicka. Du får en bekräftelse från oss när beställningen är registrerad, och betalar först när du hämtar eller får varorna levererade.',
      faq_2_question: 'Var hämtar jag min beställning?',
      faq_2_answer: 'Hämtning sker på den plats och de dagar som anges överst på sidan. Vi hör av oss med bekräftelse och tid.',
      faq_3_question: 'Kör ni hem jullådan?',
      faq_3_answer: 'Ja, vi kör hem i Göteborg med omnejd på de leveransdagar som anges överst på sidan. Skriv i meddelandet att du önskar hemkörning så bekräftar vi dag och tid.',
      faq_4_question: 'När är sista beställningsdag inför jul?',
      faq_4_answer: 'Sista beställningsdag står överst på sidan och uppdateras om den ändras. Rökt julskinka och jullådor görs i begränsade batcher, så beställ gärna i god tid.',
      faq_5_question: 'Hur betalar jag?',
      faq_5_answer: 'Betalning sker vid upphämtning eller hemkörning. Du behöver inte betala något när du skickar beställningen.',
      faq_6_question: 'Är julskinkan utan nitrit?',
      faq_6_answer: 'Ja. Vår julskinka är ekrökt och gjord utan nitritsalt, precis som resten av vår chark.',
    },
  },
};

export const getSectionSchema = (sectionKey) => SITE_CONTENT_SCHEMA[sectionKey] || null;

export const getSectionDefaults = (sectionKey) => getSectionSchema(sectionKey)?.defaults || {};

export const getSiteContentDefault = (sectionKey, fieldKey) => {
  const defaults = getSectionDefaults(sectionKey);
  const fieldAliases = getSectionSchema(sectionKey)?.fieldAliases?.[fieldKey] || [];

  if (Object.prototype.hasOwnProperty.call(defaults, fieldKey)) {
    return defaults[fieldKey];
  }

  const defaultAlias = fieldAliases.find((alias) => Object.prototype.hasOwnProperty.call(defaults, alias));
  return defaultAlias ? defaults[defaultAlias] : '';
};

export const getSectionLegacyAliases = (sectionKey) => getSectionSchema(sectionKey)?.legacySections || [];

export const getFieldCandidates = (sectionKey, fieldKey) => [
  fieldKey,
  ...(getSectionSchema(sectionKey)?.fieldAliases?.[fieldKey] || []),
];
